export default class Notification {
  notificationComponents = {};

  /**
   * Register a new notification component type.
   *
   * @param name The name of the notification type.
   * @param component The component class to render the notification.
   */
  add(name, component) {
    this.notificationComponents[name] = component;
    return this;
  }
  extend(app, extension) {
    Object.assign(app.notificationComponents, this.notificationComponents);
  }
}
flarum.reg.add('core', 'common/extenders/Notification', Notification);